import React from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../components/api/axiosInstance";
import WebsiteLeadsPanel from "../components/WebsiteLeadsPanel";

async function loadLeadStatuses() {
  const res = await axiosInstance.get("/client/lead-meta");
  return res.data?.data?.leadStatuses || [];
}

function TenantWebsiteLeads() {
  const navigate = useNavigate();
  return (
    <div className="cportal-page">
      <div className="cportal-page-head">
        <div className="cportal-page-head-left">
          <h1>Website Leads</h1>
        </div>
      </div>
      <WebsiteLeadsPanel
        apiBase="/client/website-leads"
        loadStatuses={loadLeadStatuses}
        onOpenLead={(leadId) => navigate(`/portal/leads/${leadId}`)}
      />
    </div>
  );
}

export default TenantWebsiteLeads;
